import * as React from 'react'

import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const ImportPage = React.lazy(() => import('modules/tasks/pages/employees/ImportPage'))
const IndexPage = React.lazy(() => import('modules/tasks/pages/employees/IndexPage'))
const NewPage = React.lazy(() => import('modules/tasks/pages/employees/NewPage'))
const RootPage = React.lazy(() => import('modules/tasks/pages/employees/RootPage'))
const ShowPage = React.lazy(() => import('modules/tasks/pages/employees/ShowPage'))

const employeesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.employees.id.tasks.path,
      element: <RootPage />,
      children: [
        {
          path: '',
          element: <IndexPage />,
          children: [
            {
              path: navigation.employees.id.tasks.new.path,
              element: <NewPage />,
            },
            {
              path: navigation.employees.id.tasks.import.path,
              element: <ImportPage />,
            },
          ],
        },
        {
          path: navigation.employees.id.tasks.taskId.path,
          element: <ShowPage />,
        },
      ],
    },
  ]
}

export default employeesRoutes
